import React from "react";
import clsx from "clsx";

import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { useLoggedInUser } from "components/LoggedInUserProvider";
import BarnNumberPicker from "components/BarnNumberPicker";
import StallNumberPicker from "components/StallNumberPicker";
import ScopeSign from "components/Icons/ScopeSign";
import { DASH } from "common/constants";

import useStyles from "./styles";
import useParentStyles from "../styles";

interface IProps {
  index: number;
  style: React.CSSProperties;
  horse: racehorse360.IHorse;
  selectedHorseId: string;
  mapBarns: Record<string, unknown>;
  onHorseClick: (horse: racehorse360.IHorse) => void;
  facilityBarns: Pick<racehorse360.IBarn, "id" | "name">[];
  selectedFacilityId: string;
  onHorseUpdate: (patch: racehorse360.IHorse, horseId: string) => void;
}

const HorseTableRow = (props: IProps) => {
  const {
    index,
    style,
    horse,
    selectedHorseId,
    mapBarns,
    onHorseClick,
    facilityBarns,
    selectedFacilityId,
    onHorseUpdate
  } = props;

  const classes = useStyles();
  const parentClasses = useParentStyles();

  const { currentUser } = useLoggedInUser();

  const isNoEditButton = [
    currentUser.isRegulatoryVet,
    !facilityBarns.length
  ].some(Boolean);

  const handleHorseClick = () => {
    onHorseClick(horse);
  };

  return (
    <Box
      className={clsx(parentClasses.listRow, {
        [parentClasses.evenRow]: index % 2 === 1
      })}
      style={style}
    >
      <Box
        className={clsx(parentClasses.bodyCell, parentClasses.horseNameCell)}
      >
        {horse.name}
      </Box>
      <Box
        className={clsx(
          parentClasses.bodyCell,
          parentClasses.horsePositionCell
        )}
      >
        <BarnNumberPicker
          className={clsx(classes.optionPicker, {
            noEditButton: isNoEditButton
          })}
          horse={horse}
          startActions={true}
          options={facilityBarns}
          iconVariant={"map"}
          missingValueSign={DASH}
          selectedFacilityId={selectedFacilityId}
          onBarnChange={onHorseUpdate}
        />
      </Box>
      <Box
        className={clsx(
          parentClasses.bodyCell,
          parentClasses.horsePositionCell
        )}
      >
        <StallNumberPicker
          className={clsx(classes.optionPicker, {
            noEditButton: isNoEditButton
          })}
          horse={horse}
          startActions={true}
          iconVariant={"map"}
          missingValueSign={DASH}
          selectedFacilityId={selectedFacilityId}
          onStallChange={onHorseUpdate}
        />
      </Box>
      <Box className={clsx(parentClasses.bodyCell, parentClasses.scopeCell)}>
        {horse.barn && mapBarns[horse.barn.name.toLowerCase()] && (
          <IconButton size={"small"} onClick={handleHorseClick}>
            <ScopeSign
              className={clsx(parentClasses.scopeSignIcon, {
                [parentClasses.scopeActive]: selectedHorseId === horse.id
              })}
            />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default React.memo(HorseTableRow);
